(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_topswings-pickleball-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pb-gallery')) {
    customElements.define('pb-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.pbReady) return;
        this.pbReady = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-pb-src]');
          if (!button || !this.contains(button)) return;
          const image = this.querySelector('.pb-gallery__main');
          if (!image) return;
          image.removeAttribute('srcset');
          image.src = button.dataset.pbSrc;
          image.alt = button.dataset.pbAlt;
          this.querySelectorAll('button[data-pb-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
